import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MultiselectAutocompleteComponent } from "src/app/components/multiselect-autocomplete/multiselect-autocomplete.component";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";
import { SharedService } from "src/app/services/sharedService";

@Component({
  selector: "app-vehicle-search",
  templateUrl: "./search-vehicle.component.html",
  styleUrls: ["./search-vehicle.component.css"],
})
export class SearchVehicleComponent implements OnInit {
  @ViewChild('municipalitySelect', { static: false }) municipalitySelect: MultiselectAutocompleteComponent;

  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields: any;

  municipalityChangeSubscription: any;

  filterData = {
    municipality: null,
  };
  filterFields = ["municipality"];

  queryFilter = {};
  panelOpenState = true;

  constructor(
    public categoryService: CategoryService,
    public entityService: EntityService,
    public reportService: ReportService,
    public sharedService: SharedService
  ) {}

  selectChange = (event: any, field) => {
    this.queryFilter[field] = event.data.map(elem => elem.id);
    if (this.queryFilter[field].length === 0) {
      delete this.queryFilter[field];
    }
  };

  ngOnDestroy(): void {
    if (this.municipalityChangeSubscription) this.municipalityChangeSubscription.unsubscribe();
  }

  resetFilter() {
    this.queryFilter = {};
    this.municipalitySelect.resetAll();
    this.onReset.emit();
  }

  advancedSearch() {
    let selectedMunicipalityData = this.municipalitySelect.selectData
      .filter(el => el.selected)
      .map(el => el.item.id);

    if (localStorage.getItem('municipality')) {
      if (localStorage.getItem('municipality') == "-1") {
        delete this.queryFilter['municipality'];
      } else {
        if (selectedMunicipalityData.length > 0)
          this.queryFilter['municipality'] = selectedMunicipalityData;
        else
          this.queryFilter['municipality'] = [localStorage.getItem('municipality')];
      }
    } else {
      if (this.municipalitySelect.selectData.length === 0)
        delete this.queryFilter['municipality'];
    }

    this.onFilter.emit(this.queryFilter);
    this.panelOpenState = false;
  }

  async ngOnInit() {
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      if (localStorage.getItem('municipality')) {
        if (localStorage.getItem('municipality') !== '-1') {
          this.municipalitySelect.resetAll();
          this.municipalitySelect.setSelectedData(
            this.filterData['municipality'].filter(
              elem => elem.id === localStorage.getItem('municipality')
            )
          );
        } else {
          this.municipalitySelect.resetAll();
        }
      } else {
        this.municipalitySelect.resetAll();
      }
    });

    this.filterFields.forEach((field) => {
      this.categoryService
        .getList(field)
        .subscribe((result) => {
          if (result) {
            this.filterData[field] = result.map((fld) => ({
              name: fld.name,
              id: fld.id,
            }));
          }
          setTimeout(() => {
            if (localStorage.getItem('municipality')) {
              if (localStorage.getItem('municipality') !== '-1') {
                this.municipalitySelect.resetAll();
                this.municipalitySelect.setSelectedData(
                  this.filterData['municipality'].filter(
                    elem => elem.id === localStorage.getItem('municipality')
                  )
                );
              } else {
                this.municipalitySelect.resetAll();
              }
            } else {
              this.municipalitySelect.resetAll();
            }
          }, 1000);
        });
    });
  }
}
